import './LiksPage.css';

export type LiksPageSize = 'small' | 'medium' | 'big';
export type LiksPageAlign = 'start' | 'center';

export type LiksPageProps = {
  size?: LiksPageSize;
  pageAlign?: LiksPageAlign;
  header?: React.ReactNode;
  content?: React.ReactNode;
  footer?: React.ReactNode;
  headerAlign?: LiksPageAlign;
  contentAlign?: LiksPageAlign;
  footerAlign?: LiksPageAlign;
  className?: string;
};

type LiksPageAreaProps = {
  area: 'header' | 'content' | 'footer';
  align?: LiksPageAlign;
  children: React.ReactNode;
};

function LiksPageArea({ area, align = 'start', children }: LiksPageAreaProps) {
  return (
    <div className={`liks-page__${area}`}>
      <div
        className={[
          `liks-page__${area}-inner`,
          `liks-page__${area}-inner--align-${align}`,
        ].join(' ')}
      >
        {children}
      </div>
    </div>
  );
}

export function LiksPage({
  size = 'big',
  pageAlign = 'start',
  header,
  content,
  footer,
  headerAlign = 'start',
  contentAlign = 'start',
  footerAlign = 'start',
  className,
}: LiksPageProps) {
  const classNames = [
    'liks-page',
    `liks-page--size-${size}`,
    `liks-page--page-align-${pageAlign}`,
    className,
  ].filter(Boolean);

  return (
    <div className={classNames.join(' ')}>
      {header != null && (
        <LiksPageArea area="header" align={headerAlign}>
          {header}
        </LiksPageArea>
      )}
      {content != null && (
        <LiksPageArea area="content" align={contentAlign}>
          {content}
        </LiksPageArea>
      )}
      {footer != null && (
        <LiksPageArea area="footer" align={footerAlign}>
          {footer}
        </LiksPageArea>
      )}
    </div>
  );
}
